import { MEDIA_QUERIES } from '../config'
import { checkNeedRingpool } from './checkNeedRingpool'
import { deleteButtonsRequest } from './deleteButtonsRequest'
import {
  configRingpoolForModalPage,
  deleteOutHoursDRP,
  checkDay,
  checkHour
} from './deleteOutHoursDRP'
import { setDRPForNumberCotizador } from './setDRPForNumberCoti'
import { deleteOutHoursButtons } from './deleteOutHoursButtons'
import { showModalForClientButtons } from './showModalForClientButtons'
import { pickElement, pickElementById } from './utils'
import { ALLIANZ_VARS } from '../config'

const waitForDAL = () => {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (typeof DAL !== 'undefined') {
        clearInterval(interval) // Detenemos la búsqueda
        resolve() // DAL ya está cargado
      }
    }, 100) // Revisamos cada 100 ms si DAL está cargado
  })
}

const groupControlCheckNew = async () => {
  await waitForDAL()
  return new Promise((resolve, reject) => {
    DAL.Ajax({
      type: 'jsonp',
      url: 'https://apps.walmeric.com/clients/custom/ws/verti/groupControlCheck.php',
      data: {
        idTag: ALLIANZ_VARS.idTag,
        groupName: 'pruebasGrupoControl',
        groupNumber: '10'
      }
    })
      .done(function (resp) {
        resolve(resp.number)
      })
      .fail(function (resp) {
        reject(resp.status)
      })
  })
}

export function deleteElement(id) {
  const waitForDRP = setInterval(() => {
    if (pickElementById(id)) {
      clearInterval(waitForDRP)
      pickElementById(id).style.display = 'none'
    }
  }, 50)
}

export function relocationHeaderItems() {
  const headerContainer = pickElement('.c-header-metabar__content')
  const requestBudget = pickElement('.c-header-metabar__service-link')
  const DRPContainer = pickElement('.c-header-metabar__target')
  const clientAccessContainer = pickElement('.c-header-metabar__user')

  if (headerContainer) {
    headerContainer.style.justifyContent = 'space-between'
  }

  if (clientAccessContainer) {
    clientAccessContainer.style.flexDirection = 'row-reverse'
    clientAccessContainer.style.gap = '2rem'
    clientAccessContainer.style.alignItems = 'center'

    clientAccessContainer.appendChild(requestBudget)
    clientAccessContainer.appendChild(DRPContainer)
  }
}

export function setDRPForNumber() {
  const waitForDRP = setInterval(() => {
    if (
      pickElementById('ringPoolCha') &&
      typeof DFI != "undefined" &&
      typeof DFI.telefonoRingPoolActivo != "undefined"
    ) {
      setInterval(() => {
        pickElementById('ringPoolCha').innerHTML = window.DFI.buildMaskString(
          window.DFI.telefonoRingPoolActivo,
          window.DFI.DFI_configuration.services.serviceList.ringPool.phoneMask
        )
      }, 50)

      clearInterval(waitForDRP)
    }
  })
}

export function isModal() {
  configRingpoolForModalPage()
  checkNeedRingpool()
  // deleteButtonsRequest('[id^="cta_landing_formulario_"]')
  // deleteButtonsRequest('[id^="cta_web_formulario"]')
  // if (
  //   !window.location.pathname.includes(
  //     '/seguros/landing/seguros-allianz-econtact.html'
  //   )
  // ) {
  //   deleteButtonsRequest('[id^="cta_landing_formulario_"]')
  //   deleteButtonsRequest('[id^="cta_web_formulario"]')
  // }

  if (
    window.location.href == 'https://www.allianz.es/' ||
    window.location.href == 'https://www.allianz.es/contacto.html'
  ) {
    const waitForDRPModal = setInterval(() => {
      if (
        typeof DFI.DFI_configuration != 'undefined' &&
        typeof DFI.DFI_configuration.services != 'undefined' &&
        typeof DFI.DFI_configuration.services.serviceList.ringPool.active !=
          'undefined'
      ) {
        DFI.DFI_configuration.services.serviceList.ringPool.active = false
      }

      if (typeof window.DRP !== 'undefined' && DRP.ringPoolCompleted) {
        clearInterval(waitForDRPModal)

        // borrar drp-phone, cuando action=Modal no tiene que cargar ringpool
        const elRingpoolClass = document.querySelectorAll(
          '.drp-phone, .drp-phone-new, .wal-drp-phone'
        )
        elRingpoolClass.forEach((input, i) => {
          input.remove()
        })

        DRP.stopRingPool()
      }
    }, 50)
  }

  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('dmv_bar')
    deleteElement('ringpoolMobile')
  } else {
    deleteElement('ringpoolDesktop')
    deleteElement('dsa-allianz')
    relocationHeaderItems()
  }

  // Crear un observer para observar cambios en el DOM
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const seguroInteresSelect = document.getElementById(
          'seguro-interes-select'
        )
        if (seguroInteresSelect) {
          seguroInteresSelect.addEventListener('change', function () {
            const selectedValue = seguroInteresSelect.value
            switch (selectedValue) {
              case 'coche':
                DFI.labels.EDeclaratives.ramo = '1020'
                DFI.labels.EDeclaratives.producto = 'coche'
                break
              case 'moto':
                DFI.labels.EDeclaratives.ramo = '1030'
                DFI.labels.EDeclaratives.producto = 'moto'
                break
              case 'hogar':
                DFI.labels.EDeclaratives.ramo = '1105'
                DFI.labels.EDeclaratives.producto = 'hogar'
                break
              case 'mascotas':
                DFI.labels.EDeclaratives.ramo = '1490'
                DFI.labels.EDeclaratives.producto =
                  'responsabilidad-civil-mascotas'
                break
              case 'salud':
                DFI.labels.EDeclaratives.ramo = '213'
                DFI.labels.EDeclaratives.producto = 'salud'
                break
              case 'vida':
                DFI.labels.EDeclaratives.ramo = '1901'
                DFI.labels.EDeclaratives.producto = 'vida'
                break
              case 'otros':
                DFI.labels.EDeclaratives.ramo = '9999'
                DFI.labels.EDeclaratives.producto = 'general'
                break
              default:
                DFI.labels.EDeclaratives.ramo = '9999'
                DFI.labels.EDeclaratives.producto = 'general'
                break
            }
            console.log(`Opción seleccionada: ${selectedValue}`)
          })
          // Dejar de observar una vez que se encuentra el elemento
          observer.disconnect()
        }
      }
    }
  })

  // Iniciar el observer
  observer.observe(document.body, { childList: true, subtree: true })
}

export function isButtons() {
  deleteOutHoursDRP()
  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('ringpoolMobile')
    setDRPForNumber()
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))
  } else {
    // window.DFI_client.action = 'Modal'
    showModalForClientButtons()
  }
}

export async function isTestAb() {
  try {
    // Ahora, hacemos el llamado a groupControlCheckNew y manejamos su respuesta
    let response = await groupControlCheckNew() // Usamos await aquí también
    //console.log(response)

    if (response >= 1 && response <= 10) {
      console.log('Ejecutando el comportamiento de hubtype para este usuario')
      TestAllianz()
      return
    }

    window.DFI_client.qb_test_calcular = 'A'
    window.DFI.labels.EDeclaratives = {
      ...window.DFI.labels.EDeclaratives,
      qb_test_calcular: window.DFI_client.qb_test_calcular
    }

    const labels = {
      EDeclaratives: window.DFI.labels.EDeclaratives
    }
    const checkDRP = setInterval(() => {
      if (typeof window.DRP !== 'undefined' && window.DRP.loadLabels) {
        clearInterval(checkDRP)
        window.DRP.loadLabels(labels)
      }
    }, 100)

    deleteOutHoursDRP()

    if (window.innerWidth <= MEDIA_QUERIES.tablet) {
      const today = new Date()
      const dayOfWeek = today.getDay()
      const currentHour = today.getHours()

      if (
        (dayOfWeek >= 1 &&
          dayOfWeek <= 5 &&
          currentHour >= 9 &&
          currentHour < 20) || // Lunes a Viernes de 9h a 20h
        (dayOfWeek === 6 && currentHour >= 10 && currentHour < 17) // Sábado de 10h a 17h
      ) {
        console.log('horario')
      } else {
        const mobileDSARuta = document.querySelector('#dmvText')
        mobileDSARuta.innerHTML = 'Te llamamos'
        mobileDSARuta.style.backgroundColor = 'var(--blue-7)'
      }
      deleteElement('ringpoolMobile')
      setDRPForNumber()
      deleteButtonsRequest('[id^="cta_landing_formulario_"]')
      deleteButtonsRequest('[id^="cta_web_formulario"]')
      document
        .querySelectorAll('.l-container--full-width')
        .forEach((element) =>
          element.classList.remove('l-container--full-width')
        )
    } else {
      showModalForClientButtons()
    }
  } catch (error) {
    console.error(
      'Error al obtener la respuesta del servicio de control de grupo:',
      error
    )
    if (error.response) {
      // Si hay respuesta en el error, loguea la respuesta
      console.error('Respuesta del error:', error.response)
    } else if (error.request) {
      // Si la solicitud fue hecha pero no se recibió respuesta
      console.error('No se recibió respuesta:', error.request)
    } else {
      // Error relacionado con la configuración de la solicitud
      console.error('Error configurando la solicitud:', error.message)
    }
  }
}

export function isCotizador() {
  if (
    checkDay() &&
    checkHour({
      start: 9,
      end: 20,
      customMinutes: 0
    })
  ) {
    setDRPForNumberCotizador()
  } else {
    //fuera de horario
    deleteOutHoursButtons()
  }

  deleteOutHoursDRP()

  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('ringpoolMobile')
    setDRPForNumber()
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))
    if (
      checkDay() &&
      checkHour({
        start: 9,
        end: 20,
        customMinutes: 0
      })
    ) {
      setDRPForNumberCotizador()
    }
  } else {
    // window.DFI_client.action = 'Modal'
    // deleteElement('dsa-allianz')
    showModalForClientButtons()
  }
}

export function isVoid() {
  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('ringpoolMobile')
    deleteElement('dmv_bar')
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')
  } else {
    deleteElement('ringpoolDesktop')
    deleteElement('dsa-allianz')
  }
}

export function isPubliLanding() {
  deleteOutHoursDRP()
  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')

    // Elimina la clase que causa el scroll horizontal
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))
  } else {
    deleteElement('dsa-allianz')
    showModalForClientButtons()
  }
}

export function general() {
  deleteOutHoursDRP()
  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')

    // Elimina la clase que causa el scroll horizontal
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))
  } else {
    deleteElement('dsa-allianz')
    showModalForClientButtons()
  }
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const seguroInteresSelect = document.getElementById(
          'seguro-interes-select'
        )
        if (seguroInteresSelect) {
          seguroInteresSelect.addEventListener('change', function () {
            const selectedValue = seguroInteresSelect.value
            switch (selectedValue) {
              case 'coche':
                DFI.labels.EDeclaratives.ramo = '1020'
                DFI.labels.EDeclaratives.producto = 'coche'
                console.log('coche')
                break
              case 'moto':
                DFI.labels.EDeclaratives.ramo = '1030'
                DFI.labels.EDeclaratives.producto = 'moto'
                break
              case 'hogar':
                DFI.labels.EDeclaratives.ramo = '1105'
                DFI.labels.EDeclaratives.producto = 'hogar'
                break
              case 'mascotas':
                DFI.labels.EDeclaratives.ramo = '1490'
                DFI.labels.EDeclaratives.producto =
                  'responsabilidad-civil-mascotas'
                break
              case 'salud':
                DFI.labels.EDeclaratives.ramo = '213'
                DFI.labels.EDeclaratives.producto = 'salud'
                break
              case 'vida':
                DFI.labels.EDeclaratives.ramo = '1901'
                DFI.labels.EDeclaratives.producto = 'vida'
                break
              case 'otros':
                DFI.labels.EDeclaratives.ramo = '9999'
                DFI.labels.EDeclaratives.producto = 'general'
                break
              default:
                DFI.labels.EDeclaratives.ramo = '9999'
                DFI.labels.EDeclaratives.producto = 'general'
                break
            }
            console.log(`Opción seleccionada: ${selectedValue}`)
          })
          // Dejar de observar una vez que se encuentra el elemento
          observer.disconnect()
        }
      }
    }
  })

  // Iniciar el observer
  observer.observe(document.body, { childList: true, subtree: true })
}

export function notDRP() {
  showModalForClientButtons()
  checkNeedRingpool()

  if (pickElement('.c-header-metabar__content.c-header__wrapper')) {
    const headerWrap = pickElement(
      '.c-header-metabar__content.c-header__wrapper'
    )

    headerWrap.style.justifyContent = 'space-between'

    if (window.innerWidth <= MEDIA_QUERIES.tablet) {
      deleteElement('dmv_bar')
      deleteElement('ringpoolMobile')
    } else {
      deleteElement('ringpoolDesktop')
      deleteElement('dsa-allianz')
    }
  }
}

export function coinscrap() {
  deleteOutHoursDRP()

  let buttons = document.querySelectorAll(
    'a[id^="cta_web_qb"], a[id^="cta_landing_qb"], a#dmvtext'
  )
  buttons.forEach(function (button) {
    appendParamsToButtonUrl(button)
  })

  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('ringpoolMobile')
    setDRPForNumber()
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')
    hideButtonsByPartialId('cta_web_qb')
    hideButtonsByPartialId('cta_landing_qb')

    // Elimina la clase que causa el scroll horizontal
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))
    const currentUrl = window.location.href
    // Observador de mutaciones para esperar a que #dmvText esté disponible
    const observer = new MutationObserver((mutations, observer) => {
      const mobileDSARuta = document.querySelector('#dmvText')
      const mobileDSARutaDos = document.querySelector('#ringPoolCha')

      if (
        mobileDSARuta &&
        mobileDSARutaDos &&
        currentUrl !== 'https://www.allianz.es/seguros-vida.html'
      ) {
        mobileDSARuta.href = 'https://segurosdevida.allianz.es/webapp/client/'
        mobileDSARuta.innerText = 'Calcular precio'
        mobileDSARuta.style.backgroundColor = 'var(--orange-7)'

        if (mobileDSARutaDos) {
          mobileDSARutaDos.style.backgroundColor = 'var(--blue-7)'
        }
        if (
          mobileDSARuta &&
          mobileDSARutaDos &&
          window.location.hostname === 'www.allianz.es' &&
          window.location.pathname === '/seguros-vida.html'
        ) {
          mobileDSARuta.innerText = 'TE LLAMAMOS'
        } else {
          console.log('prueba')
        }

        // Aplicar la función para concatenar los parámetros
        appendParamsToButtonUrl(mobileDSARuta)

        // Sobrescribir el evento onclick para evitar que abra la modal
        mobileDSARuta.onclick = function (event) {
          event.preventDefault()
          window.location.href = mobileDSARuta.href
        }

        observer.disconnect() // Detener la observación después de encontrar el elemento
        console.log('Elemento encontrado y modificado')
      }
    })

    // Configurar el observador para observar cambios en el nodo body y sus descendientes
    observer.observe(document.body, { childList: true, subtree: true })
  } else {
    deleteElement('dsa-allianz')
    showModalForClientButtons()
  }
}

export function isVida() {
  deleteOutHoursDRP()

  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('ringpoolMobile')
    setDRPForNumber()
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))
    const observer = new MutationObserver(() => {
      const mobileDSARuta = document.querySelector('#dmvText')

      const pedirPresu = document.querySelector(
        '.c-header-mobile__service-link'
      )
      if (mobileDSARuta) {
        // pedirPresu.style.display = "none"
        mobileDSARuta.href = 'https://segurosdevida.allianz.es/webapp/client/'

        observer.disconnect() // Detener la observación después de encontrar el elemento
      }
    })

    // Configurar el observador para observar cambios en el nodo body y sus descendientes
    observer.observe(document.body, { childList: true, subtree: true })
  } else {
    deleteElement('dsa-allianz')
    showModalForClientButtons()
  }
}

export function isCallme() {
  configRingpoolForModalPage()
  checkNeedRingpool()

  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('dmv_bar')
    deleteElement('ringpoolMobile')
    showModalForClientButtons()
    const observer = new MutationObserver(() => {
      const pedirPresu = document.querySelector(
        '[id^="cta_landing_formulario_"]'
      )
      if (pedirPresu) {
        // pedirPresu.style.display = "none"
        pedirPresu.href = ''
        observer.disconnect() // Detener la observación después de encontrar el elemento
      }
    })

    // Configurar el observador para observar cambios en el nodo body y sus descendientes
    observer.observe(document.body, { childList: true, subtree: true })
  } else {
    deleteElement('ringpoolDesktop')
    window.DFI_client.action = 'Modal'
    showModalForClientButtons()
  }
}

export function hubtype() {
  deleteOutHoursDRP()

  let buttons = document.querySelectorAll(
    'a[id^="cta_web_qb"], a[id^="cta_landing_qb"]'
  )
  buttons.forEach(function (button) {
    appendParamsToButtonUrl(button)
  })
  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    deleteElement('ringpoolMobile')
    setDRPForNumber()
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')
    hideButtonsByPartialId('cta_web_qb')
    hideButtonsByPartialId('cta_landing_qb')

    // Elimina la clase que causa el scroll horizontal
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))

    // Observador de mutaciones para esperar a que #dmvText esté disponible
    const targetNode = document.body
    const config = { childList: true, subtree: true }

    const observerCallback = () => {
      const mobileDSARuta = document.querySelector('#dmvText')
      const mobileDSARutaDos = document.querySelector('#ringPoolCha')

      if (mobileDSARuta && mobileDSARutaDos) {
        mobileDSARuta.href =
          'https://protecciondatos.allianz.es/PetsWebview?context=%7B%22bot%22%3A+%7B%22id%22%3A+%22a44ad435-bbb7-4c70-a0a7-69b3ae4462e7%22%2C+%22name%22%3A+%22ALLIANZ_PRO_ES%22%7D%2C+%22user%22%3A+%7B%22id%22%3A+%2200000000-0000-0000-0000-000000000000%22%2C+%22imp_id%22%3A+%2234638930466%22%2C+%22username%22%3A+null%2C+%22extra_data%22%3A+%7B%22country%22%3A+%22ES%22%2C+%22retries%22%3A+0%2C+%22language%22%3A+%22es%22%7D%2C+%22provider_id%22%3A+%2200000000-0000-0000-0000-000000000000%22%7D%2C+%22_hubtype_api%22%3A+%22https%3A%2F%2Fapi.hubtype.com%22%2C+%22organization%22%3A+%22ALLIANZ%22%2C%22organization_id%22%3A+%22f69adfb8-ec6e-40df-9480-b48231227fa4%22%7D&'
        mobileDSARuta.innerText = 'Calcular precio'
        mobileDSARuta.style.backgroundColor = 'var(--orange-7)'
        mobileDSARutaDos.style.backgroundColor = 'var(--blue-7)'
        observer.disconnect()
        console.log('Elemento encontrado y modificado')

        appendParamsToButtonUrl(mobileDSARuta)
        mobileDSARuta.onclick = function (event) {
          event.preventDefault()
          window.location.href = mobileDSARuta.href
        }
      }
    }

    const observer = new MutationObserver(observerCallback)
    observer.observe(targetNode, config)
  } else {
    deleteElement('dsa-allianz')
    showModalForClientButtons()
  }
}

export function TestAllianz() {
  deleteOutHoursDRP()

  window.DFI_client.qb_test_calcular = 'B'
  window.DFI.labels.EDeclaratives = {
    ...window.DFI.labels.EDeclaratives,
    qb_test_calcular: window.DFI_client.qb_test_calcular
  }

  const labels = {
    EDeclaratives: window.DFI.labels.EDeclaratives
  }
  const checkDRP = setInterval(() => {
    if (typeof window.DRP !== 'undefined' && window.DRP.loadLabels) {
      clearInterval(checkDRP)
      window.DRP.loadLabels(labels)
    }
  }, 100)

  let buttons = document.querySelectorAll(
    'a[id^="cta_web_formulario_herobanner_coche"], a[id^="cta_web_formulario_rtbs_coche"], a[id^="cta_landing_formulario_coche"]'
  )
  buttons.forEach(function (button) {
    appendParamsToButtonUrl(button)
  })

  // Si es Mobile
  if (window.innerWidth <= MEDIA_QUERIES.tablet) {
    const today = new Date()
    const dayOfWeek = today.getDay()
    const currentHour = today.getHours()

    if (
      (dayOfWeek >= 1 &&
        dayOfWeek <= 5 &&
        currentHour >= 9 &&
        currentHour < 20) || // Lunes a Viernes de 9h a 20h
      (dayOfWeek === 6 && currentHour >= 10 && currentHour < 17) // Sábado de 10h a 17h
    ) {
      console.log('horario')
    } else {
      const mobileDSARuta = document.querySelector('#dmvText')
      mobileDSARuta.innerHTML = 'Calcular precio'
      mobileDSARuta.style.backgroundColor = 'var(--orange-7)'
      mobileDSARuta.href =
        'https://calcularseguro.allianz.es/coche/journey-home'

      appendParamsToButtonUrl(mobileDSARuta)
    }

    deleteElement('ringpoolMobile')
    setDRPForNumber()
    deleteButtonsRequest('[id^="cta_landing_formulario_"]')
    deleteButtonsRequest('[id^="cta_web_formulario"]')
    hideButtonsByPartialId('cta_web_qb')
    hideButtonsByPartialId('cta_landing_qb')

    // Elimina la clase que causa el scroll horizontal
    document
      .querySelectorAll('.l-container--full-width')
      .forEach((element) => element.classList.remove('l-container--full-width'))

    // Observador de mutaciones para esperar a que #dmvText esté disponible
    const targetNode = document.body
    const config = { childList: true, subtree: true }

    let contObserver = 0

    const observerCallback = () => {
      const mobileDSARuta = document.querySelector('#dmvText')
      const mobileDSARutaDos = document.querySelector('#ringPoolCha')

      if (mobileDSARuta && mobileDSARutaDos) {
        observer.disconnect()
        console.log('Elemento encontrado y modificado')

        mobileDSARuta.href =
          'https://calcularseguro.allianz.es/coche/journey-home'
        mobileDSARuta.innerText = 'Calcular precio'
        mobileDSARuta.style.backgroundColor = 'var(--orange-7)'
        mobileDSARutaDos.style.backgroundColor = 'var(--blue-7)'

        appendParamsToButtonUrl(mobileDSARuta)

        mobileDSARuta.onclick = function (event) {
          event.preventDefault()
          window.location.href = mobileDSARuta.href
        }
      } else if (mobileDSARuta) {
        observer.disconnect()

        appendParamsToButtonUrl(mobileDSARuta)
        mobileDSARuta.innerHTML = 'CALCULAR PRECIO'
      }

      if (contObserver >= 10000) {
        observer.disconnect()
      }

      contObserver++
    }

    const observer = new MutationObserver(observerCallback)
    observer.observe(targetNode, config)
  } else {
    deleteElement('dsa-allianz')
    showModalForClientButtons()
    const targetNode = document.body
    const config = { childList: true, subtree: true }

    let contObserver = 0

    const observerCallback = () => {
      const mobileDSARuta =
        window.location.href.indexOf(
          'https://www.allianz.es/seguros/landing/coche/seguros-de-coches-w-calcular.html'
        ) >= 0
          ? document.querySelector('#cta_landing_formulario_coche')
          : document.querySelector('#cta_web_formulario_herobanner_coche')

      // Selección de botones
      let buttons = document.querySelectorAll(
        'a[id^="cta_web_formulario_rtbs_coche"], ' +
          'a[id^="cta_landing_formulario_coche"], ' +
          'a[id^="cta_web_formulario_destacados_terceros_coche"], ' +
          'a[id^="cta_web_formulario_destacados_tercerosampliado_coche"], ' +
          'a[id^="cta_web_formulario_coche"]'
      )

      let buttonsBlan = document.querySelectorAll(
        'a[id^="cta_web_formulario_destacados_todoriesgo_coche"], ' +
          'a[id^="cta_web_formulario_timeline_coche"], ' +
          'a[id^="cta_web_formulario_xsell_coche"], ' +
          'a[id^="cta_web_formulario_xcell_coche"]'
      )

      // Aplicar la configuración a los botones de color naranja
      buttons.forEach((button) => {
        configureButton(button, 'var(--orange-7)', 'var(--orange-7)', 'white')
      })

      // Aplicar la configuración a los botones de color blanco (para los botones "black")
      buttonsBlan.forEach((button) => {
        configureButton(button, 'var(--orange-7)', 'var(--orange-7)', 'white')
      })

      if (mobileDSARuta) {
        observer.disconnect()
        console.log('Elemento encontrado y modificado')

        mobileDSARuta.href =
          'https://calcularseguro.allianz.es/coche/journey-home'
        mobileDSARuta.innerText = 'Calcular precio'
        mobileDSARuta.style.backgroundColor = 'var(--orange-7)'
        mobileDSARuta.style.borderColor = 'var(--orange-7)'

        appendParamsToButtonUrl(mobileDSARuta)

        const clone = mobileDSARuta.cloneNode(true)
        if (mobileDSARuta.parentNode) {
          mobileDSARuta.parentNode.replaceChild(clone, mobileDSARuta) // Reemplazamos el original por el clon
        }

        // Asignamos el nuevo evento de redirección al clon
        clone.onclick = function (event) {
          event.preventDefault()
          window.location.href = clone.href
        }
      }

      if (contObserver >= 10000) {
        observer.disconnect()
      }

      contObserver++
    }

    const observer = new MutationObserver(observerCallback)
    observer.observe(targetNode, config)
  }
}

function hideButtonsByPartialId(partialId) {
  const buttons = document.querySelectorAll(`[id*="${partialId}"]`)
  buttons.forEach((button) => (button.style.display = 'none'))
}

function configureButton(button, bgColor, borderColor, colorLe) {
  if (button.parentNode) {
    // Verificamos si el botón tiene un parentNode
    button.href = 'https://calcularseguro.allianz.es/coche/journey-home'
    button.innerText = 'Calcular precio'
    button.style.backgroundColor = bgColor
    button.style.borderColor = borderColor
    button.style.color = colorLe

    appendParamsToButtonUrl(button)

    const buttonClone = button.cloneNode(true)
    button.parentNode.replaceChild(buttonClone, button)

    // Asignamos el evento al clon
    buttonClone.onclick = function (event) {
      event.preventDefault()
      window.location.href = buttonClone.href
    }
  } else {
    console.log('Botón sin parentNode', button)
  }
}

function getQueryParams() {
  let params = {}
  let queryString = window.location.search.substring(1)
  if (queryString) {
    let queryArray = queryString.split('&')
    queryArray.forEach(function (param) {
      let pair = param.split('=')
      params[pair[0]] = decodeURIComponent(pair[1])
    })
  }
  return params
}

function appendParamsToButtonUrl(button) {
  let params = getQueryParams()
  if (button) {
    let baseUrl = button.getAttribute('href')
    if (baseUrl) {
      let url = new URL(baseUrl, window.location.origin)
      for (let key in params) {
        if (params.hasOwnProperty(key)) {
          url.searchParams.append(key, params[key])
        }
      }
      button.setAttribute('href', url.toString())
    }
  }
}
